import { inject, Injectable } from '@angular/core';
import { EventBasic } from './models/events/event-basic.model';
import { EventDetailed } from './models/events/event-detailed.model';
import { EventBookingBasic } from './models/event-bookings/event-booking-basic.model';
import { Observable } from 'rxjs';
import { EventComplete } from './models/events/event-complete.model';
import { ApiWrapperService } from 'ngx-apiwrapper';
import { EventAttendee } from './models/events/event-attendees.model';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private readonly _apiWrapper = inject(ApiWrapperService);

  getUpcomingEvents(eventSystem?: string): Observable<EventBasic[]> {
    return this._apiWrapper.get<EventBasic[]>(`events${eventSystem ? '?system=' + eventSystem : ''}`)
  }

  getEvent(id: string): Observable<EventDetailed> {
    return this._apiWrapper.get<EventDetailed>(`events/${id}`);
  }

  getAttendees(eventId: number) {
    return this._apiWrapper.get<EventAttendee[]>(`events/${eventId}/attendees`);
  }

  adminGetEventList() : Observable<EventComplete[]> {
    return this._apiWrapper.get<EventComplete[]>(``)
  }
}
